import { isEmpty } from "lodash";

export const useOnError = notify => error => {
  const { field_errors: resFieldErrors, internal_error: resInternalErrors } =
    error.body?.errors || {};
  if (error.body) {
    let fieldErrors = "";
    if (!isEmpty(resFieldErrors)) {
      // eslint-disable-next-line no-restricted-syntax
      for (const prop in resFieldErrors) {
        // eslint-disable-next-line prefer-destructuring
        fieldErrors += `${resFieldErrors[prop][0]}\n`;
      }
      notify(fieldErrors, {
        type: "error",
      });
      return;
    }
    notify(resInternalErrors, {
      type: "error",
    });
  }
};
